<!-- https://github.com/angular/angular/issues/24567 -->

<ng-container *ngIf="isExternalUrl(); else isLocalUrl">
  <a
    sdLink
    role="link"
    [href]="url | sdSafeUrl"
    [attr.target]="target"
    [attr.rel]="rel"
    [attr.class]="class"
    [attr.id]="id"
    [attr.style]="style"
    [attr.title]="title"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-template #isLocalUrl>
  <a
    sdLink
    role="link"
    [routerLink]="routerUrl"
    [routerLinkActive]="routerLinkActive"
    [queryParams]="queryParams"
    [fragment]="fragment"
    [attr.target]="target"
    [attr.class]="class"
    [attr.id]="id"
    [attr.style]="style"
    [attr.title]="title"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
